// extracted by mini-css-extract-plugin
export default {"root":"ScrollToTop_root__VJbwj","icon":"ScrollToTop_icon__b4fes"};